import { composeCompanyLegalCopy, type CompanyLegalDetails } from "./format-company-legal-copy"
import styles from "./company-legal-notice.module.css"

export default function CompanyLegalNotice({
  footer,
  variant,
}: {
  footer: CompanyLegalDetails
  variant: "footer" | "cart" | "checkout"
}) {
  const { companyName, address, identity, taxStatement } = composeCompanyLegalCopy(footer)
  if (variant !== "footer" && !address && !taxStatement) return null
  if (!identity && !taxStatement) return null

  return (
    <div className={`${styles.notice} ${styles[variant]}`} data-testid="company-legal-notice">
      {identity ? (
        <p className={styles.identity}>
          {companyName ? <strong className={styles.name}>{companyName}</strong> : null}
          {companyName && address ? " " : null}
          {address}
        </p>
      ) : null}
      {taxStatement ? <p className={styles.taxStatement}>{taxStatement}</p> : null}
    </div>
  )
}
